import { render, staticRenderFns } from "./EntityTypePropertiesSection.vue?vue&type=template&id=51f93a4a&"
import script from "./EntityTypePropertiesSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EntityTypePropertiesSection.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports